function Portfolio() {
    return (
        <main>

        <style>{`
            .portfolio-grid .card-img-scale-wrapper {
                aspect-ratio: 16 / 9;
                width: 100%;
                background-color: #f5f5f5;
            }

            .portfolio-grid .card-img-scale-wrapper img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
                object-position: center;
            }
        `}</style>

       

        <section class="bg-dark position-relative pt-xl-8 overflow-hidden">
            
            
            <div class="position-absolute top-0 start-0 mt-n9 ms-n5">
                <img src="assets/images/elements/grad-shape/blur-decoration.svg" class="blur-7 opacity-2" alt="Grad shape"/>
            </div>

            
            <div class="position-absolute top-0 start-50 mt-n9 ms-n9">
                <img src="assets/images/elements/grad-shape/blur-decoration.svg" class="blur-8 opacity-1" alt="Grad shape"/>
            </div>
            

            
            <div class="inner-container text-center mx-auto position-relative pt-4 pt-sm-5">
                
                <nav class="mb-2 d-flex justify-content-center" aria-label="breadcrumb">
                    <ol class="breadcrumb breadcrumb-dark pt-0">
                        <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Portfolio</li>
                    </ol>
                </nav>
                
                <h1 class="mb-5 text-white">Our Portfolio</h1>
            </div>

            
            <span>
        <svg className="position-absolute bottom-0 start-0 mb-n1 mb-lg-n5 mb-xxl-n7" viewBox="0 0 1950 237" style={{ enableBackground: "new 0 0 1950 237" }} xmlSpace="preserve">
    			<path className="fill-body" d="M1949.5,236.4H0v-164c717.2-131.2,1598.5-54.7,1949.5,0V236.4z"/>
		</svg>
	</span>
        </section>
       


       

        <section class="position-relative pt-3">
            <div class="container">
                
  
                <div class="portfolio-grid row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4 g-lg-5 mb-5">
                    
                 
                    
                    <div class="col">
                        <div class="card card-img-scale card-content-hover overflow-hidden rounded-4">
                            <div class="card-img-scale-wrapper">
                                
                                <a href="https://rudraindustries.ltd/" class="stretched-link"><img src="assets/images/portfolio/3by4/09.png" class="img-scale" alt="portfolio-img"/></a>
                            </div>
                        </div>
                    </div>


                    
                    <div class="col">
                        <div class="card card-img-scale card-content-hover overflow-hidden rounded-4">
                            <div class="card-img-scale-wrapper">
                                
                                <a href="https://www.apex-advisors.co.in/" class="stretched-link"><img src="assets/images/portfolio/3by4/04.png" class="img-scale" alt="portfolio-img"/></a>
                            </div>
                        </div>
                    </div>

                      <div class="col">
                        <div class="card card-img-scale card-content-hover overflow-hidden rounded-4">
                            <div class="card-img-scale-wrapper">
                                
                                <a href="https://www.archistechnology.com/" class="stretched-link"><img src="assets/images/portfolio/3by4/13.png" class="img-scale" alt="portfolio-img"/></a>
                            </div>
                        </div>
                    </div>

                  

                    
                   

                    
                    <div class="col">
                        <div class="card card-img-scale card-content-hover overflow-hidden rounded-4">
                            <div class="card-img-scale-wrapper">
                                
                                <a href="https://kroxtechnologies.com/" class="stretched-link"><img src="assets/images/portfolio/3by4/02.jpg" class="img-scale" alt="portfolio-img"/></a>
                            </div>
                        </div>
                    </div>

                    
                  

                    
                    <div class="col">
                        <div class="card card-img-scale card-content-hover overflow-hidden rounded-4">
                            <div class="card-img-scale-wrapper">
                                
                                <a href="https://vatsalgroup.in/" class="stretched-link"><img src="assets/images/portfolio/3by4/08.png" class="img-scale" alt="portfolio-img"/></a>
                            </div>
                        </div>
                    </div>
                    

                     <div class="col">
                        <div class="card card-img-scale card-content-hover overflow-hidden rounded-4">
                            <div class="card-img-scale-wrapper">
                                
                                <a href="https://www.voltshirebuildandelectrics.co.uk/" class="stretched-link"><img src="assets/images/portfolio/3by4/11.png" class="img-scale" alt="portfolio-img"/></a>
                            </div>
                        </div>
                    </div>
                       
                     <div class="col">
                        <div class="card card-img-scale card-content-hover overflow-hidden rounded-4">
                            <div class="card-img-scale-wrapper">
                                
                                <a href="https://ryverb.com/" class="stretched-link"><img src="assets/images/portfolio/3by4/12.png" class="img-scale" alt="portfolio-img"/></a>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card card-img-scale card-content-hover overflow-hidden rounded-4">
                            <div class="card-img-scale-wrapper">
                                
                                <a href="#" class="stretched-link"><img src="assets/images/portfolio/3by4/01.webp" class="img-scale" alt="portfolio-img"/></a>
                            </div>
                        </div>
                    </div>

                     <div class="col">
                        <div class="card card-img-scale card-content-hover overflow-hidden rounded-4">
                            <div class="card-img-scale-wrapper">
                                
                                <a href="#" class="stretched-link"><img src="assets/images/portfolio/3by4/07.png" class="img-scale" alt="portfolio-img"/></a>
                            </div>
                        </div>
                    </div>

                      <div class="col">
                        <div class="card card-img-scale card-content-hover overflow-hidden rounded-4">
                            <div class="card-img-scale-wrapper">
                                
                                <a href="#" class="stretched-link"><img src="assets/images/portfolio/3by4/06.png" class="img-scale" alt="portfolio-img"/></a>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </section>
       


       

        <section class="pt-0">
            <div class="container">
                <div class="bg-secondary-grad position-relative rounded-3 overflow-hidden p-4 p-sm-6">

                    
                    <div class="position-absolute end-0 top-0 rotate-343 mt-n5 me-7 d-none d-sm-block">
                        <img src="assets/images/elements/geo-grad-pattern.svg" class="h-500px opacity-3" alt="bg pattern"/>
                    </div>

                    
                    <div class="position-absolute start-0 top-0 rotate-343 mt-n5 ms-n8">
                        <img src="assets/images/elements/geo-grad-pattern.svg" class="h-300px opacity-1" alt="bg pattern"/>
                    </div>

                    <div class="row g-4 align-items-center position-relative">
                        
                        <div class="col-xl-6">
                            <h2>Ready to transform your <span class="text-primary-grad">vision</span> into reality?</h2>
                            <ul class="list-inline d-flex flex-wrap gap-2 mb-0 mt-3">
                                <li class="list-inline-item heading-color"> <i class="bi bi-check-circle text-success me-1"></i>Free Prototype
                                </li>
                                <li class="list-inline-item heading-color"> <i class="bi bi-check-circle text-success me-1"></i>Delivery in 72 hours</li>
                            </ul>
                        </div>

                        
                        <div class="col-xl-6 text-xl-end">
                            <a href="contact-us.html" class="btn btn-dark mb-0">Let's work together</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       


    </main>
    )
}

export default Portfolio;